/** Read template opening purpose from default_config.respondent_framing. */
export function templateOpeningPurpose(defaultConfig: Record<string, unknown> | null | undefined): string {
  const raw = defaultConfig?.respondent_framing;
  if (!raw || typeof raw !== 'object') return '';
  const opening = (raw as Record<string, unknown>).opening;
  if (!opening || typeof opening !== 'object') return '';
  const purpose = (opening as Record<string, unknown>).purpose;
  return typeof purpose === 'string' ? purpose.trim() : '';
}
